import styled from "styled-components";
import { Box, Divider, Link } from "@mui/material";
import type { Theme } from "../../constants/themeConstants";

export const ContactLink = styled( Link )`
  && {
    color: ${ ( { theme } ) => ( theme as Theme )?.colors.textColor };
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0;

    width: fit-content;

    transition: color 0.3s ease;
    text-decoration: none;

    #text {
      vertical-align: middle;
    }
    vertical-align: middle;

    &:hover {
      color: ${ ( { theme } ) => ( theme as Theme )?.colors.hoverTextColor };
    }

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }
`;

export const ContactLinks = styled( Box )`
  && {
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-top: 48px;

    @media (max-width: 768px) {
      margin-top: 0;
    }
  }
`;

export const ContactItem = styled( Box )`
  && {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: fit-content;
    align-items: center;

    padding-bottom: 4px;
    border-bottom: 2px solid
      ${ ( { theme } ) => ( theme as Theme )?.colors.textColor };

      svg {
        width: 32px;
        height: 32px;
      }
    @media (max-width: 768px) {
      align-items: center;
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

export const ContactDividerLine = styled( Divider )`
  background: ${ ( { theme } ) => ( theme as Theme )?.colors.gray };
`;